import { AbstractControl, ValidationErrors } from '@angular/forms';

const PHONE_NUMBER_REGEXP = /^\+[1-9]\d{1,14}$/;

export function isValidPhoneNumber(value: string): boolean {
  return PHONE_NUMBER_REGEXP.test(value);
}

export function phoneNumberError(): ValidationErrors {
  return { invalidPhoneNumber: true };
}

export function phoneNumberValidator(control: AbstractControl): ValidationErrors | null {
  return !isValidPhoneNumber(control.value) ? phoneNumberError() : null;
}
